webpackJsonp([100692885119331],{

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.HomeView = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import rootComponent from "../index.jsx"
	// import HomeView from "home"
	var HomeView = exports.HomeView = function (_React$Component) {
		_inherits(HomeView, _React$Component);
	
		function HomeView() {
			_classCallCheck(this, HomeView);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		HomeView.prototype.componentDidMount = function componentDidMount() {
			window.location.replace("https://winpeforum.com/connect");
		};
	
		HomeView.prototype.render = function render() {
			// // console.log("this.props", this.props)
			return _react2.default.createElement("div", null);
		};
	
		return HomeView;
	}(_react2.default.Component);
	
	exports.default = HomeView;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-connect-index-js-4d3656d193e4990abab5.js